import * as UserApi from "../api/UserRequest";


export const updateUser=(id, userFormData)=> async(dispatch)=> {
    console.log(userFormData);
    dispatch({type: "UPDATING_START"})
    try{
        const {data} = await UserApi.updateUser(id, userFormData);
        dispatch({type: "UPDATING_SUCCESS", data: data})
    }   
    catch(error){
        dispatch({type: "UPDATING_FAIL"})
    }
}

export const followUser = (id, data) => async(dispatch) => {
    dispatch({type: "FOLLOW_USER"})
    await UserApi.followUser(id, data);
}

export const unFollowUser = (id, data) => async(dispatch) => {
    dispatch({type: "UNFOLLOW_USER"})
    await UserApi.unFollowUser(id, data);
}